(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-fb-finder]').forEach(finder => {
      if (finder.dataset.ready) return;
      finder.dataset.ready = 'true';
      finder.querySelector('[data-fb-pace]').addEventListener('change', event => {
        finder.querySelectorAll('[data-fb-result]').forEach(result => {
          result.hidden = event.target.value !== 'all' && result.dataset.fbResult !== event.target.value;
        });
      });
    });
  };
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.fb-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.fb-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  initialize();
})();
